import { checkPhone, checkZip } from 'app/actions';
import { apiCall } from 'app/dealer/actions';

import * as ActionTypes from './constants';

export const getNetwork = () => async dispatch => {
  const url = '/networks/me';

  dispatch({ type: ActionTypes.FETCH_NETWORK_REQUEST });
  try {
    const payload = await dispatch(apiCall(url, {}, true, true));

    dispatch({
      type: ActionTypes.FETCH_NETWORK_SUCCESS,
      payload,
    });
  } catch (error) {
    dispatch({
      type: ActionTypes.FETCH_NETWORK_FAILURE,
      error,
    });
  }
};

export const updateNetwork = network => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_NETWORK,
      payload: network,
    });
  };
};

export const submitNetwork = () => {
  return (dispatch, getState) => {
    const networkState = getState().network;
    const { network } = networkState;
    const url = network.id ? '/networks/me' : '/networks/';
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(network),
    };

    dispatch({ type: ActionTypes.SUBMIT_NETWORK_REQUEST });
    return dispatch(apiCall(url, requestOptions, true, true))
      .then(payload => {
        dispatch({
          type: ActionTypes.SUBMIT_NETWORK_SUCCESS,
          payload,
        });

        return Promise.resolve();
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.SUBMIT_NETWORK_FAILURE,
          error,
        });

        return Promise.reject();
      });
  };
};

export const resetNetwork = () => {
  return { type: ActionTypes.RESET_NETWORK };
};

export const resetNetworkStates = () => {
  return { type: ActionTypes.RESET_NETWORK_STATES };
};

export const checkNetworkPhone = phone => {
  return dispatch => {
    dispatch({ type: ActionTypes.CHECK_NETWORK_PHONE_REQUEST });
    return dispatch(checkPhone(phone))
      .then(() => {
        dispatch({
          type: ActionTypes.CHECK_NETWORK_PHONE_SUCCESS,
          payload: phone,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.CHECK_NETWORK_PHONE_FAILURE,
          payload: phone,
        });
      });
  };
};

export const checkResponsiblePersonPhone = phone => {
  return dispatch => {
    dispatch({
      type: ActionTypes.CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_REQUEST,
    });
    return dispatch(checkPhone(phone))
      .then(() => {
        dispatch({
          type: ActionTypes.CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_SUCCESS,
          payload: phone,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_FAILURE,
          payload: phone,
        });
      });
  };
};

export const checkNetworkZip = zip => {
  return dispatch => {
    dispatch({ type: ActionTypes.CHECK_NETWORK_ZIP_REQUEST });
    return dispatch(checkZip(zip))
      .then(() => {
        dispatch({
          type: ActionTypes.CHECK_NETWORK_ZIP_SUCCESS,
          payload: zip,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.CHECK_NETWORK_ZIP_FAILURE,
          payload: zip,
        });
      });
  };
};

export const closeAddPaymentMethodNotification = () => {
  return { type: ActionTypes.CLOSE_ADD_PAYMENT_METHOD_NOTIFICATION };
};
